import React from "react";
import { useTranslation } from "react-i18next";
import { DataRow } from "@outpave/ds";
import { Stack } from "components/layout/reusableLayouts";
import type { PlatformRewardRuleSummary } from "./types";

const ProgramSettings: React.FC<{
  summary: PlatformRewardRuleSummary | null;
}> = ({ summary }) => {
  const { t } = useTranslation();
  if (!summary) return null;
  return (
    <Stack>
      <DataRow
        label={t("Maturity period")}
        tooltip={t("MaturityPeriodTooltip")}
        primaryTrailing={t("RewardsMaturityDays", {
          count: summary.maturityDays,
        })}
      />
      <DataRow
        label={t("Coverage warning")}
        tooltip={t("CoverageWarningTooltip")}
        primaryTrailing={t("CoverageWarningBelow", {
          percent: summary.coverageThresholdPercent,
        })}
      />
      <DataRow
        label={t("Rule precedence")}
        tooltip={t("RulePrecedenceExplanation")}
        primaryTrailing={t("Lowest priority number wins")}
      />
      <DataRow
        label={t("Monthly caps")}
        tooltip={t("MonthlyCapExplanation")}
        primaryTrailing={t("Falls to the next rule")}
      />
    </Stack>
  );
};

export default ProgramSettings;
